




















import Vue from 'vue'

export default Vue.extend({
    name: 'ReleaseNotes',

    data(){
        return {
            releaseNotes:[
                {
                    version: '3.27.07',
                    notes: [
                        'Fixed an Any Table bug where Unity lookup and dropdown columns displayed internal IDs instead of their actual values.'
                    ]
                },
                {
                    version: '3.27.06',
                    notes: [
                        'Add Advance search to calendar events. Users can now search and filter calendar events using the advance search feature.'
                    ]
                },
                {
                    version: '3.27.05',
                    notes: [
                        'Fix bug on maps where drawing manager is being removed from the map.',
                        'Fix bug on calendar events where you cannot create an event with fields having special characters',
                        'Fix bug on some search pages where certain fields when filtered are not working as expected'
                    ]
                },
                {
                    version: '3.27.04',
                    notes: [
                        'Made search compatible with AI OCR data source. Users can now search and view AI OCR related data in Any Table search.'
                    ]
                },
                {
                    version: '3.27.03',
                    notes: [
                        'Fix Niva chat issue.'
                    ]
                },
                {
                    version: '3.27.02',
                    notes: [
                        'Fix AI OCR fields to support or detect "date" field.'
                    ]
                },
                {
                    version: '3.27.01',
                    notes: [
                        'Fix AI OCR routing where page returns 404 on page refresh.'
                    ]
                },
                {
                    version: '3.27.00',
                    notes: [
                        'Added AI OCR to options of available Any Table data sources. Users can now search and view AI OCR related data.',
                    ]
                },
                {
                    version: '3.26.01',
                    notes: [
                        'Fix Calendar bug where the calendar would not load because the system contains Unity events.'
                    ]
                },
                {
                    version: '3.26.00',
                    notes: [
                        'Improve Any Table search performance by eliminating Data Sync'
                    ]
                },
                {
                    version: '3.25.24',
                    notes: [
                        'Fix Any Table search bug where the search returned empty result even if theres data in the table.'
                    ]
                },
                {
                    version: '3.25.23',
                    notes: [
                        'Fix Any Table creation bug where the table could not be created under certain conditions.'
                    ]
                },
                {
                    version: '3.25.22',
                    notes: [
                        'Improve Any Table sync.'
                    ]
                },
                {
                    version:'3.25.21',
                    notes: [
                        'Add new feature - Merge Templates, which allows users to create and manage templates for mail merge functionality. Users can create templates with dynamic fields that can be populated with data from the system, streamlining the process of generating personalized documents such as letters, contracts, and reports.',
                    ]
                },
                {
                    version:'3.25.20',
                    notes: [
                        'Implemented UX improvements for loading items in Reports, Quantum Charts and Dashboard. Name of the creator is now included and also added scrolling when items exceed the max height of the menu.',
                    ]
                },
                {
                    version:'3.25.19',
                    notes: [
                        'Implemented UX improvements for saving theme settings.',
                        'Implemented bug fixes for configuring and interacting with the \'Need Help\' and \'Suggest a Feature\' modules.'
                    ]
                },
                {
                    version:'3.25.18',
                    notes: [
                        'UX Improvements for Reports: Users can now see the report creator. Additionally, when a report is loaded or saved by someone other than the owner, the "Make Public" option is now unchecked by default.',
                    ]
                },
                {
                    version:'3.25.17',
                    notes: [
                        'Bug fixes, and introduced a new message when a user is trying to access a page that they don\'t have permissions to.',
                    ]
                },
                {
                    version:'3.25.16',
                    notes: [
                        'Added New feature - Calendar, which allows user to add then view events using page and their date columns.',
                    ]
                },
                {
                    version:'3.25.15',
                    notes: [
                        'Further Optimize Any table sync.',
                    ]
                },
                {
                    version:'3.25.14',
                    notes: [
                        'Optimize Any Table and Propconn Legacy sync.',
                    ]
                },
                {
                    version:'3.25.13',
                    notes: [
                        'Further optimize Unity sync.',
                    ]
                },
                {
                    version:'3.25.12',
                    notes: [
                        'Optimize Unity sync.',
                    ]
                },
                {
                    version:'3.25.11',
                    notes: [
                        'Improved Any Table data synchronization to gracefully handle incompatible data types (e.g., string to numeric), ensuring the sync continues by setting the target field to empty instead of erroring out.',
                    ]
                },
                {
                    version:'3.25.10',
                    notes: [
                        'Added a new column in the property page to show the Company General Ledger associated with the property.',
                        'Added support for static jump links on the property page.'
                    ]
                },
                {
                    version:'3.25.9',
                    notes: [
                        'Security Improvements and Improved Niva to support answering questions across other pages.',
                    ]
                },
                {
                    version:'3.25.8',
                    notes: [
                        'Yardi Data Sync Improvements - Added ability to transform Yardi data to Property and Vendors data',
                    ]
                },
                {
                    version:'3.25.7',
                    notes: [
                        'Dashboard improvements - Fix a bug where the source doesn\'t appear when selecting a chart while creating a dashboard.',
                    ]
                },
                {
                    version:'3.25.6',
                    notes: [
                        'Any Table improvements - Added the ability to add Yardi data/tables',
                    ]
                },
                {
                    version:'3.25.5',
                    notes: [
                        'Jumplinks Enhancements - Added the ability to remove parts from a jumplink and made some UI improvements to the jumplinks editor.',
                    ]
                },
                {
                    version:'3.25.4',
                    notes: [
                        'Enhancement to Any Table Synchronization.',
                    ]
                },
                {
                    version:'3.25.3',
                    notes: [
                        'Enhancement to Property, Units, Tenants and Vendors page.',
                    ]
                },
                {
                    version:'3.25.2',
                    notes: [
                        'Introduced Dashboards feature.',
                    ]
                },
                {
                    version:'3.25.1',
                    notes: [
                        'Any Table data sync bug fixes.',
                    ]
                },
                {
                    version:'3.25.0',
                    notes: [
                        'Implement ability to import data from Unity.',
                    ]
                },
                {
                    version:'3.24.0',
                    notes: [
                        'UI Enhancements.',
                    ]
                },
                {
                    version:'3.23.6',
                    notes: [
                        'Niva chat enhancements.',
                    ]
                },
                {
                    version:'3.23.5',
                    notes: [
                        'PropConn Multi-Tenant Enhancements.',
                    ]
                },
                {
                    version:'3.23.4',
                    notes: [
                        'Bug Fixes.',
                    ]
                },
                {
                    version:'3.23.3',
                    notes: [
                        'Security Improvements.',
                    ]
                },
                {
                    version:'3.23.2',
                    notes: [
                        'Resolved GMap icon settings save issue.',
                    ]
                },
                {
                    version:'3.23.1',
                    notes: [
                        'Added new column Other Expenses in Accounting',
                        'Added new column Miscellaneous Expense File Admin. Fee in Accounting',
                        'Added new column Subcontractor Expenses - Internal in Accounting',
                        'Added new column Subcontractor Expenses - External in Accounting'
                    ]
                },
                {
                    version:'3.23.0',
                    notes: [
                        'Security Improvements.',
                    ]
                },
                {
                    version:'3.22.7',
                    notes: [
                        'Quantum Chart Improvements - Added Median Function',
                    ]
                },
                {
                    version:'3.22.6',
                    notes: [
                        'Quantum Chart Improvements.',
                    ]
                },
                {
                    version:'3.22.5',
                    notes: [
                        'Security Improvements.',
                    ]
                },
                {
                    version:'3.22.4',
                    notes: [
                        'Sync Improvements.',
                    ]
                },
                {
                    version:'3.22.3',
                    notes: [
                        'Sync Improvements.',
                    ]
                },
                {
                    version:'3.22.2',
                    notes: [
                        'Security enhancements.',
                    ]
                },
                {
                    version:'3.22.1',
                    notes: [
                        'Added the Total Expense column in Accounting Page.',
                    ]
                },
                {
                    version:'3.22.0',
                    notes: [
                        'Added the new Formula Fields feature, allowing users to create custom formulas for fields within the system.',
                    ]
                },
                {
                    version:'3.21.3',
                    notes: [
                        'Fix Jobs and Accounting data sync issue.',
                    ]
                },
                {
                    version: '3.21.2',
                    notes: [
                        'Security patches and system improvements.',
                    ]
                },
                {
                    version: '3.21.1',
                    notes: [
                        'Introduced new column in Jobs called "Signed Date"'
                    ]
                },
                {
                    version: '3.21.0',
                    notes: [
                        'Introduced the new "Aggregate Fields" feature, allowing users to create aggregate fields dynamically.',
                        'System Improvements'
                    ]
                },
                {
                    version: '3.20.3',
                    notes: [
                        'Added Mileage as a column in Accounting.',
                        'The Accounting page will now default to displaying no columns to improve load time.',
                        'The list of reports will now be loaded first, before loading the page data.'
                    ]
                },
                {
                    version: '3.20.2',
                    notes: [
                        'Removed Mileage as a row expense in Accounting',
                    ]
                },
                {
                    version: '3.20.1',
                    notes: [
                        'Modified Proof Of Delivery Date column in Accounting to pull from Invoice',
                    ]
                },
                {
                    version: '3.20.0',
                    notes: [
                        'Added Department Name Column in Accounting Page',
                        'Mileage should now appear as an expense in the Accounting Page. It will be displayed as a row with NULL in its Billable column.',
                    ]
                },
                {
                    version: '3.19.1',
                    notes: [
                        'Fix handling of users without lastname',
                    ]
                },
                {
                    version: '3.19.0',
                    notes: [
                        'Fix Clawback Amount Formula in Accounting',
                        'Improved Niva integration',
                        'Add Capability for Sync to Store Invoice-Level POD (Job POD Will Still Be Displayed in the UI)'
                    ]
                },
                {
                    version: '3.18.8',
                    notes: [
                        'Added new fields returned by the Properties API, added new column Approved Payment in Accounting'
                    ]
                },
                {
                    version: '3.18.7',
                    notes: [
                        'PropConn improvements'
                    ]
                },
                {
                    version: '3.18.6',
                    notes: [
                        'Accounting bug fixes for Write-Offs and added a new filter field called Approved Payment in Accounting'
                    ]
                },
                {
                    version: '3.18.5',
                    notes: [
                        'System improvements'
                    ]
                },
                {
                    version: '3.18.4',
                    notes: [
                        'Added voided write-offs to the Write-Off Report and Payment Received Report in Accounting.'
                    ]
                },
                {
                    version: '3.18.3',
                    notes: [
                        'Made improvements to PropConn'
                    ]
                },
                {
                    version: '3.18.2',
                    notes: [
                        'Ported Niva into PropConn',
                        'Apply security updates',
                        'Improved PropConn Sync'
                    ]
                },
                {
                    version: '3.18.1',
                    notes: [
                        'Improved Quantum Charts by adding the ability to show calculated row and column totals. Also added the ability to easily expand and collapse all headers and pivot on specific date intervals (Year, Quarter, Month, Day) instead of just one big group.'
                    ]
                },
                {
                    version: '3.18.0',
                    notes: [
                        'Fixed a bug where unauthenticated users going to private pages redirects to 404 page.',
                        'Enhanced Accounting Invoice Balance and BD AR Balance Calculation, both values are now calculated based on the Invoice Date filter.'
                    ]
                },
                {
                    version: '3.17.6',
                    notes: [
                        'Fixed a bug where timestamps were included in columns that are dates when exporting data to XLSX.'
                    ]
                },
                {
                    version:'3.0.00',
                    notes:[
                        'Released a new UI using the Vue JS framework'
                    ]
                },
                {
                    version:'2.7.47',
                    notes:[
                        'Added Company Code, Property Name, Property Address and City in Property Units search grid'
                    ]
                },
                {
                    version:'2.7.45',
                    notes:[
                        'Added Upper and Lower Tier Municipality in Propery Details page'
                    ]
                },
                {
                    version:'2.7.43',
                    notes:[
                        'Added new fields in Property Details &gt; Additional Details section: Bill To Entity, Remit To Entity &amp; Nominee / Registered Owner'
                    ]
                },
                {
                    version:'2.7.42',
                    notes:[
                        'Added Correlated Company Code in Property Search and Details Page'
                    ]
                },
                {
                    version:'2.7.41',
                    notes:[
                        'Added Roof Leaks button in Property Details'
                    ]
                },
                {
                    version:'2.7.40',
                    notes:[
                        'Upgraded .Net Framwework to 4.8',
                        'Updated Bootstrap CSS Framework to maximize screen real estate on larger screens'
                    ]
                },
                {
                    version:'.7.38',
                    notes:[
                        'Added sticky search grid headers (header row remains visible when scrolling down list views)'
                    ]
                },                
                {
                    version:'2.7.36',
                    notes:[
                        'Added Release Notes',
                        'Added Security Deposit in Tenant &gt; Additional Details section',
                        'Added Property Admin, Property Accounting Manager and Property Accountant in Property &gt; Contacts section',
                        'Added feature to remember map visibility preference in Property and Tenant details page',
                        'Fixed issue with handling direct links/return URLs',
                        'Updated Suggest a Feature link',
                    ]
                },
                {
                    version:'2.7.30',
                    notes:[
                        'Changed the sort order of commonly searched fields in Advanced Search',
                        'Removed trailing empty spaces in the database to fix search issues'
                    ]
                },
                {
                    version:'2.7.29',
                    notes:[
                        'Added button in Property Search to filter the grid view based on the selected area in map view',
                        'Updated Tenant Statement and AR Report Links',
                        'Added predictive search support for Property, Tenant and Vendor search',
                        'Upgraded bootstrap version to 3.4.1 to fix XSS vulnerability issues',
                        'Modified the property search page to display all properties in map view and get rid of paging'
                    ]
                },

            ]
        }
    },
})
